export const SIGN_UP = '/register';
export const SIGN_IN = '/login';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const DASHBOARD = '/dashboard';
export const DISCUSSION = '/discussion';
export const LOGOUT = '/login'
export const DONATION = '/donation';
export const TIPS = '/advice';
export const CHAT = '/chat';
export const PAGE_NOT_FOUND = '*';